import styled, { css } from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const LoginWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  padding-bottom: 100px;
`;

export const LoginContent = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 2px 4px rgba(${({ theme }) => theme.colors.rgb.blue8PercentOpacity});
  border-radius: 8px;
  width: 35%;
  // text-align: center;
  /* margin-bottom: 50px; */
  padding: 35px;
  box-sizing: border-box;
`;

export const LoginLogo = styled.img``;

export const LoginInputLabel = styled(typography.BodyTextOneBoldTypography)`
  color: ${({ theme }) => theme.colors.black};
`;

export const LoginInput = styled.input`
  width: 100%;
  height: 45px;
  padding: 14px 20px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
  border: 2px solid ${({ theme }) => theme.colors.grey003};
  border-radius: 4px;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  ::-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-ms-input-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }
  :-moz-placeholder {
    font-size: 13px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.grey002};
  }

  &:focus {
    border: 2px solid ${({ theme }) => theme.colors.blueMain};
    outline: none;
  }
`;

export const LoginValidationErrMsg = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
`;

export const LoginBtn = styled(typography.BodyTextOneRegularTypography)`
  padding: 8px 40px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
`;

export const extendLoaderStyle = css`
  margin: auto;
`;
